// The version is automatically overwritten by the CI
export const version = '5.1.2'
